import React, { useState } from "react";
import useStats from "./utils";
import StatsStateWise from "./pages/statsStateWise";
import { BeatLoader } from "react-spinners";
const CountrySelector = () => {
  const { stats, error, loading } = useStats(
    "https://covid19.mathdro.id/api/countries"
  );
  //console.log(stats);
  const [selectedCountry, setSelectedCountry] = useState("India");
  if (loading) return <BeatLoader loading color="red" />;
  return (
    <div>
      <h1 style={{ paddingLeft: "20px" }}>
        Currently Showing : {selectedCountry}
      </h1>
      <select
        className="countrySelect"
        onChange={e => {
          setSelectedCountry(e.target.value);

          if (window.innerWidth >= 480) {
            window.scrollTo(0, 500);
          } else {
            window.scrollTo(0, 1200);
          }
        }}
      >
        <option value="DEFAULT" selected disabled>
          Choose a Country ...
        </option>
        {Object.entries(stats.countries).map(([name, index]) => {
          // console.log(name + "====" + index.name);
          return (
            <option
              key={name}
              selected={selectedCountry === index.name}
              value={index.name}
            >
              {index.name}
            </option>
          );
        })}
      </select>
      <div className="">
        <StatsStateWise
          url={`https://covid19.mathdro.id/api/countries/${selectedCountry}`}
        />
      </div>
    </div>
  );
};

export default CountrySelector;
